import React from 'react'
import { makeStyles } from '@material-ui/core'
import clsx from 'clsx'
const useStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.secondary.main,
    textDecoration: 'none',
    fontFamily: 'Roboto,"Helvetica",Muli,Arial,sans-serif',
  },
}))
const TextSecondary = (props) => {
  const classes = useStyles()
  return <span className={clsx(classes.root)}>{props.children}</span>
}

export default TextSecondary
